import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Pricing from "@/pages/Pricing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App mv-grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0d0d0d",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
